/**
 * Deux signaux :
 * - intro-start : début du reveal grille → zoom hero en parallèle
 * - site-ready : fin du reveal → textes split-reveal, etc.
 */
const EVENT_READY = "meral:site-ready";
const EVENT_INTRO = "meral:intro-start";

let ready = false;
let introStarted = false;
const readyQueue = [];
const introQueue = [];

export function markIntroStart() {
	if (introStarted) return;
	introStarted = true;
	document.dispatchEvent(new CustomEvent(EVENT_INTRO));
	introQueue.splice(0).forEach((fn) => fn());
}

export function whenIntroStart(fn) {
	if (introStarted) fn();
	else introQueue.push(fn);
}

export function markSiteReady() {
	if (ready) return;
	ready = true;
	document.dispatchEvent(new CustomEvent(EVENT_READY));
	readyQueue.splice(0).forEach((fn) => fn());
}

export function whenSiteReady(fn) {
	if (ready) fn();
	else readyQueue.push(fn);
}

export function isSiteReady() {
	return ready;
}
